export default "__VITE_ASSET__WrLoYCmY__";